module.exports = __webpack_public_path__ + "static/img/color.9a929f76.jpg";